import React from "react";
import "./AdvisoryHighlights.css";
import advisoryCouncilImg from "../../../images/advisory council.png";

const AdvisoryHighlights = () => {
  const helpPoints = [
    "Validate skills frameworks",
    "Design performance-based certification",
    "Navigate regulatory environments",
    "Ensure employer credibility",
  ];

  return (
    <section className="advisory-highlights-wrapper mx-lg-5 mb-5">
      <div className="container ">
        
          <div className="row align-items-start g-4">
            {/* LEFT CONTENT */}
            <div className="col-lg-4 order-2 justify-content-start order-lg-1 p-0">
              <div className="advisory-help-content">
                <h3 className="advisory-help-title">They help us:</h3>

                {helpPoints.map((item, index) => (
                  <div className="advisory-help-item" key={index}>
                    <h2 className="advisory-help-number">
                      {String(index + 1).padStart(2, "0")}
                    </h2>
                    <p className="advisory-help-text">{item}</p>
                  </div>
                ))}
              </div>
            </div>

            {/* IMAGE */}
            <div className="col-lg-7 offset-lg-1 order-1 order-lg-2">
              <div className="advisory-image-wrapper">
                <img
                  src={advisoryCouncilImg}
                  alt="Advisory council"
                  className="img-fluid advisory-main-image"
                />

                {/* Desktop paragraph */}
                <p className="advisory-bottom-text advisory-bottom-text-desktop">
                  Because skills-based hiring only works if employers trust the
                  signal.
                </p>
              </div>
            </div>

            {/* Tablet / Mobile paragraph */}
            <div className="col-12 order-3 d-lg-none">
              <p className="advisory-bottom-text advisory-bottom-text-mobile">
                Because skills-based hiring only works if employers trust the
                signal.
              </p>
            </div>
          </div>
        </div>
   
    </section>
  );
};

export default AdvisoryHighlights;